import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { formatDateToDDMMYYYY_HHMMSS } from "../../../utils/formatDate";
import { getUno } from "../../../api/apis";
import "../../../css/modal.css";

const MonitorModal = ({ show, row, onClose }) => {
  const [procesos, setProcesos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && row?.id) {
      setLoading(true);
      getUno("monitor/procesos", { contrato_id: row.id })
        .then(res => {
          setTimeout(() => {
            if (res?.data?.data) {
              setProcesos(res.data.data);
            } else if (res?.data) {
              setProcesos(res.data);
            } else {
              setProcesos([]);
            }
            setLoading(false);
          }, 600);
        })
        .catch(err => {
          console.error("Error al consultar procesos:", err);
          setTimeout(() => {
            setProcesos([]);
            setLoading(false);
          }, 600);
        });
    } else {
      setProcesos([]);
    }
  }, [show, row]);

  const getStatusText = (keyword, approvedKey, rejectedKey, pendingKey) => {
    if (!Array.isArray(procesos) || procesos.length === 0) return "N/A";
    const p = procesos
      .slice()
      .reverse()
      .find(p => (p.estado || "").includes(keyword));
    if (!p) return "N/A";
    if (p.estado === approvedKey) {
      return (
        <span title={formatDateToDDMMYYYY_HHMMSS(p.created_at)} style={{ cursor: "help" }}>
          Aprobado
        </span>
      );
    }
    if (p.estado === rejectedKey) {
      return (
        <span title={formatDateToDDMMYYYY_HHMMSS(p.created_at)} style={{ cursor: "help" }}>
          Rechazado
        </span>
      );
    }
    if (p.estado === pendingKey) {
      return "En espera";
    }
    return p.estado;
  };

  if (!show || !row) return null;

  const rrhhStatus = getStatusText("RRHH", "APROBADO_RRHH", "RECHAZADO_RRHH", "ESPERA_RRHH");
  const jefeStatus = getStatusText("ADMINISTRADOR", "APROBADO_ADMINISTRADOR", "RECHAZADO_ADMINISTRADOR", "ESPERA_ADMINISTRADOR");
  const colabStatus = getStatusText("COLABORADOR", "FIRMADO_COLABORADOR", "RECHAZADO_COLABORADOR", "ESPERA_COLABORADOR");

  const docs = row.documentos && row.documentos.length > 0 ? row.documentos : ["Documento"];

  return (
    <>
      <div className="modal-backdrop show" style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 1040 }}></div>
      <div className="modal show" style={{ display: "block", position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 1050, pointerEvents: "none" }}>
        <div className="modal-dialog modal-xl modal-dialog-centered" style={{ pointerEvents: "auto" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Estado documentos</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: "1em", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "center", background: "#f8f9fa", borderRadius: "8px", padding: "12px 8px", fontSize: "16px", fontWeight: 500 }}>
                <div>
                  <span style={{ color: "#14406e" }}>
                    <strong>Email colaborador</strong>
                  </span>
                  <br />
                  <span>{row.EmailColaborador ?? "No disponible"}</span>
                </div>
                <div>
                  <span style={{ color: "#14406e" }}>
                    <strong>En curso desde</strong>
                  </span>
                  <br />
                  <span>{row.created_at ? formatDateToDDMMYYYY_HHMMSS(row.created_at) : "No disponible"}</span>
                </div>
              </div>

              <div className="table-responsive modal-table-container">
                <table className="table table-sm table-hover mb-0 modal-table">
                  <thead className="table-light sticky-top" style={{ top: 0, zIndex: 5 }}>
                    <tr style={{ background: "#dbe7f6" }}>
                      <th style={{ background: "transparent" }}>
                        <span className="small fw-semibold text-truncate">DOCUMENTO</span>
                      </th>
                      <th style={{ background: "transparent" }}>
                        <span className="small fw-semibold text-truncate">JEFE REMUNERACIONES</span>
                      </th>
                      <th style={{ background: "transparent" }}>
                        <span className="small fw-semibold text-truncate">JEFE INMEDIATO</span>
                      </th>
                      <th style={{ background: "transparent" }}>
                        <span className="small fw-semibold text-truncate">COLABORADOR</span>
                      </th>
                      <th style={{ background: "transparent" }}>
                        <span className="small fw-semibold text-truncate">RECORDATORIO</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center py-5">
                          <div className="spinner-border text-primary mb-2" style={{ width: "2rem", height: "2rem" }}>
                            <span className="visually-hidden">Cargando...</span>
                          </div>
                          <div className="text-muted fw-semibold">Consultando procesos...</div>
                        </td>
                      </tr>
                    ) : (
                      docs.map((doc, idx) => {
                        const id = Number.parseInt(idx);

                        return (
                          <tr key={id}>
                            <td style={{ color: "#222", fontSize: 13, padding: "7px 8px", verticalAlign: "middle" }}>{typeof doc === "string" ? doc : doc.nombre_documento || "Documento"}</td>
                            <td style={{ color: "#222", fontSize: 13, padding: "7px 8px", verticalAlign: "middle" }}>{rrhhStatus}</td>
                            <td style={{ color: "#222", fontSize: 13, padding: "7px 8px", verticalAlign: "middle" }}>{jefeStatus}</td>
                            <td style={{ color: "#222", fontSize: 13, padding: "7px 8px", verticalAlign: "middle" }}>{colabStatus}</td>
                            <td style={{ color: "#222", fontSize: 13, padding: "7px 8px", verticalAlign: "middle" }}>{row.fecha_recordatorio && row.fecha_recordatorio !== "N/A" ? formatDateToDDMMYYYY_HHMMSS(row.fecha_recordatorio) : ""}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MonitorModal.propTypes = {
  show: PropTypes.bool,
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    documentos: PropTypes.array,
    created_at: PropTypes.string,
    EmailColaborador: PropTypes.string,
    fecha_recordatorio: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

export default MonitorModal;
